import React, { Component } from 'react';
import { Link, StaticQuery, graphql, withPrefix } from 'gatsby';

class Footer extends Component {
  constructor(props) {
    super(props);
  }

  handleScrollToTop = (e) => {
    e.preventDefault();

    window.scrollTo({top: 0, behavior: 'smooth'});
  }

  render() {
    const { commonPage, data } = this.props;
    const { wpPage: page } = data;
    const download = page.template ? page.template.tplDownloads.annualReport : null;
    let downloadTitle = '';

    if ( download.title.includes('Download') ) {
      downloadTitle = download.title;
    } else {
      downloadTitle = 'Download ' + download.title;
    }

    return (
      <footer>
        <div className="container">
          { commonPage.commonPage && (
            <div className="page-nav">
              <div className="left-page w-1/2">
                { commonPage.commonPage.previousPage && (
                  <Link to={commonPage.commonPage.previousPage.uri} className="left-page">
                    <div className="caret">
                      <img src={withPrefix('/images/icons/caret-left.svg')} alt="caret-icon" />
                    </div>

                    <div className="text-base lg:text-md font-bold mt-2 lg:mt-0 lg:ml-6 text-left">
                      {commonPage.commonPage.previousPage.title}
                    </div>
                  </Link>
                )}
              </div>

              <div className="right-page w-1/2">
                { commonPage.commonPage.nextPage && (
                  <Link to={commonPage.commonPage.nextPage.uri} className="right-page">
                    <div className="caret">
                      <img src={withPrefix('/images/icons/caret-right.svg')} alt="caret-icon" />
                    </div>

                    <div className="text-base lg:text-md font-bold mt-2 lg:mt-0 lg:mr-6 text-right">
                      {commonPage.commonPage.nextPage.title}
                    </div>
                  </Link>
                )}
              </div>
            </div>
          )}

          <button className="back-to-top mt-8" type="button" onClick={this.handleScrollToTop}>
            <img src={withPrefix('/images/icons/arrow-up.svg')} alt="arrow-icon" />
            <div className="font-bold mt-4">Back to top</div>
          </button>

          { download.file &&
            <div className="mt-8">
              <a href={download.file.localFile.publicURL} className="btn btn-main-download" target="_blank" rel="noopener noreferrer">
                <div className="font-bold">{downloadTitle}</div>
                <img className="ml-2 block download-icon" src={withPrefix('/images/icons/download-red.svg')} alt="download-red-icon" />
                <img className="ml-2 hidden download-hover-icon" src={withPrefix('/images/icons/download.svg')} alt="download-icon" />
              </a>
            </div>
          }

          <div className="social-wrapper">
            <a className="social-link" href="https://www.linkedin.com/company/singtel/" target="_blank" rel="noopener noreferrer">
              <img src={withPrefix('/images/icons/linkedin.svg')} alt="linkedin" />
            </a>
            <a className="social-link" href="https://twitter.com/singtel/" target="_blank" rel="noopener noreferrer">
              <img src={withPrefix('/images/icons/twitter.svg')} alt="twitter" />
            </a>
            <a className="social-link" href="https://www.facebook.com/singtel/" target="_blank" rel="noopener noreferrer">
              <img src={withPrefix('/images/icons/facebook.svg')} alt="facebook" />
            </a>
          </div>

          <div className="copyright">
            Copyright {new Date().getFullYear()} Singtel (CRN: 199201624D).
          </div>
        </div>
      </footer>
    );
  }
}

export default function FooterComponent( commonPage ) {
  return (
    <StaticQuery
      query={graphql`
          query {
            wpPage(template: {templateName: {eq: "Downloads"}}) {
              template {
                ... on WpTemplate_Downloads {
                  tplDownloads {
                    annualReport {
                      title
                      file {
                        localFile {
                          publicURL
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        `}

        render= {data => <Footer data={data} commonPage={commonPage} />}
    />
  );
}

// export const pageQuery = graphql`
//   {
//     themeOptions {
//       themeOptions {
//         facebook
//         fieldGroupName
//         linkedin
//         twitter
//       }
//     }
//   }
// `
